import { render, staticRenderFns } from "./GGanttChart.vue?vue&type=template&id=c8c7c7ae&scoped=true"
import script from "./GGanttChart.vue?vue&type=script&lang=js"
export * from "./GGanttChart.vue?vue&type=script&lang=js"
import style0 from "./GGanttChart.vue?vue&type=style&index=0&id=c8c7c7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c7c7ae",
  null
  
)

export default component.exports